import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Chip,
} from '@mui/material';
import { motion } from 'framer-motion';
import { GRADIENTS, RADIUS_LIBRARIAN as RADIUS } from '../../../theme/tokens';
import { MOCK_STUDENTS } from '../crmMockData';

const STATUS_META = {
  active: { label: 'Active', color: '#16A34A', bg: 'rgba(22,163,74,0.1)' },
  expiring: { label: 'Expiring', color: '#F59E0B', bg: 'rgba(245,158,11,0.12)' },
  expired: { label: 'Expired', color: '#DC2626', bg: 'rgba(220,38,38,0.1)' },
};

const AVATAR_COLORS = [
  GRADIENTS.brand,
  'linear-gradient(135deg, #1B365D 0%, #0EA5E9 100%)',
  'linear-gradient(135deg, #16A34A 0%, #4ADE80 100%)',
  'linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)',
];

function DemoStudentsTab() {
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1" fontWeight={800}>
          Students
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {MOCK_STUDENTS.length} members enrolled
        </Typography>
      </Box>

      <Card sx={{ borderRadius: RADIUS.xl }}>
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
          <List disablePadding>
            {MOCK_STUDENTS.map((student, idx) => {
              const status = STATUS_META[student.status] || STATUS_META.active;
              return (
                <motion.div
                  key={student.id}
                  initial={{ opacity: 0, x: -12 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: idx * 0.06, duration: 0.28, ease: 'easeOut' }}
                >
                  <ListItem divider sx={{ px: 2, py: 1.25 }}>
                    <ListItemAvatar sx={{ minWidth: 44 }}>
                      <Avatar
                        sx={{
                          width: 34,
                          height: 34,
                          background: AVATAR_COLORS[idx % AVATAR_COLORS.length],
                          fontSize: '0.8rem',
                          fontWeight: 700,
                        }}
                      >
                        {student.initial}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="body2" fontWeight={600} noWrap>
                          {student.name}
                        </Typography>
                      }
                      secondary={
                        <Typography variant="caption" color="text.secondary" noWrap>
                          {student.plan} · since {student.joinedDate}
                        </Typography>
                      }
                    />
                    <Chip
                      label={status.label}
                      size="small"
                      sx={{
                        height: 20,
                        fontSize: '0.62rem',
                        fontWeight: 700,
                        color: status.color,
                        bgcolor: status.bg,
                      }}
                    />
                  </ListItem>
                </motion.div>
              );
            })}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
}

export default DemoStudentsTab;
